export const BreadcrumbElements = {
	currentPageBreadcrumb: 'currentPageBreadcrumb',
};
